<template>
    <div class="cardReportes">
        <vs-row>
            <vs-col class="p-3">
                <h4>Archivo Domiciliación ({{mes}} {{year}})</h4>
                <!-- <h5>Total de pagos con opción a domiciliar: <strong>105</strong></h5> -->
            </vs-col>
            <vs-row> 
                <vs-col sm="12" lg="4" class="mt-2">
                    <form autocomplete="off">
                        <label for="institucion" class="labelInput">
                            Institución
                        </label>
                        <vs-select class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" v-if="instituciones.length" :disabled="!instituciones.length" autocomplete="off" @input="getAcciones(); cicloEscolar = ''; grupo = ''" >
                            <template v-if="instituciones.length" autocomplete="off">
                                <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </template>
                            <template v-else>
                                <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                </vs-option>
                            </template>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4" class="mt-2">
                    <form autocomplete="off">
                        <label for="cicloEscolar" class="labelInput">
                            Ciclo Escolar
                        </label>
                        <vs-select :loading="loadingCiclo" class="aqui pt-0" id="cicloEscolar" placeholder="Seleccionar Ciclo Escolar" :key="cicloId" v-model="cicloEscolar" v-if="instituciones.length" :disabled="!ciclosEscolares.length" autocomplete="off" @input="grupo = ''">
                            <template v-if="ciclosEscolares.length" autocomplete="off">
                                <vs-option v-for="option in ciclosEscolares" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </template>
                            <template v-else>
                                <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                </vs-option>
                            </template>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4" class="mt-2">
                    <div class="d-flex " style="justify-content: space-between;">
                        <label for="grupo" class="labelInput">
                            Grupo
                        </label>
                        <div class="d-flex" v-if="grupos[0]">
                            <div> 
                                <vs-tooltip>
                                    <i class="fas fa-check-square" style="cursor:pointer" @click="selectAll(grupos, 'grupos')"></i>
                                    <template #tooltip>
                                        Seleccionar todo
                                    </template>
                                </vs-tooltip>
                            </div>
                            <div class="labelInput">
                                <vs-tooltip>
                                    <i class="far fa-times-circle" style="cursor:pointer" @click="deseleccionarAll('grupos')"></i>
                                    <template #tooltip>
                                        Deseleccionar todo
                                    </template>
                                </vs-tooltip>
                            </div>
                            
                        </div>
                    </div>
                    <div style="position: relative">
                        <vs-select
                            :loading="loadingGrupo"
                            filter
                            multiple
                            collapse-chips
                            class="pt-0"
                            id="grupo"
                            placeholder="Seleccionar grupo"
                            :key="gruposId"
                            v-model="grupo"
                            :disabled="!grupos.length">
                            <vs-option v-for="option in grupos" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </vs-select>
                    </div>
                    <p v-if="errorGrupo == true" class="red"><strong> Campo Requerido </strong></p>
                </vs-col>
                <!-- <vs-col sm="12" lg="4" class="mt-2">
                    <form autocomplete="off">
                        <label for="institucion" class="labelInput">
                            Banco
                        </label>
                        <vs-select filter class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="bancoId" v-model="banco" autocomplete="off">
                            <vs-option label="Banamex" value="banamex">
                                Banamex
                            </vs-option>
                                <vs-option v-for="option in bancoNombre" :key="option.id"  :label="option.nombre" :value="option.id">
                                    {{option.nombre}}
                                </vs-option>
                        </vs-select>
                    </form>
                </vs-col> -->
            </vs-row>
            <vs-col lg="12" class="mb-4">
                <vs-button
                    class="ml-auto"
                    @click="getInformacion()"
                >
                    <i class="fas fa-search mr-2"></i> Buscar
                </vs-button>
            </vs-col>
            <!-- <vs-row class="p-3">
                <vs-col sm="12" lg="2">
                    <p>Monto a Cobrar</p>
                </vs-col>
                <vs-col sm="12" lg="10" class="d-flex">
                    <vs-radio class="ml-2 mr-2" v-model="montoCobrar" val="1">
                        Antes
                    </vs-radio>
                    <vs-radio class="ml-2 mr-2" v-model="montoCobrar" val="2">
                        Después
                    </vs-radio>
                    <vs-radio class="ml-2 mr-2" v-model="montoCobrar" val="3">
                        Intermedia
                    </vs-radio>
                </vs-col>
            </vs-row> -->
            <vs-row >
                <vs-col class="d-flex" style="justify-content: flex-end">
                    <vs-button
                        flat
                        @click="getArchivoBancos('banamex')"
                        :disabled="selected == ''"
                    >
                         DESCARGAR ARCHIVO <span class="ml-1"><strong> BANAMEX</strong></span>
                    </vs-button>
                    <vs-button
                        flat
                        danger
                        @click="getArchivoBancos('hsbc')"
                        v-if="banco == '7'"
                    >
                         DESCARGAR ARCHIVO <span class="ml-1"><strong> HSBC</strong></span>
                    </vs-button>
                </vs-col>
            </vs-row>
            <vs-col lg="4" class="ml-auto">
                 <vs-input v-model="search" placeholder="Buscar">
                    <template #icon>
                        <i class="fas fa-search"></i>
                    </template>
                </vs-input>
            </vs-col>
            <vs-table
                v-model="selected"
                >
                <template #thead>
                <vs-tr>
                    <vs-th style="width: 30px !important">
                        <vs-checkbox
                            :indeterminate="selected.length == users.length" v-model="allCheck"
                            @change="selected = $vs.checkAll(selected, users)"
                        />
                    </vs-th>
                    <vs-th @click="users = $vs.sortData($event ,users, 'nombre')">
                        Nombre
                    </vs-th>
                    <vs-th @click="users = $vs.sortData($event ,users, 'programa')">
                        Programa
                    </vs-th>
                    <vs-th @click="users = $vs.sortData($event ,users, 'matricula')">
                        Matrícula
                    </vs-th>
                    <vs-th @click="users = $vs.sortData($event ,users, 'concepto')">
                        Concepto
                    </vs-th>
                    <vs-th @click="users = $vs.sortData($event ,users, 'monto')">
                        Monto
                    </vs-th>
                    <vs-th @click="users = $vs.sortData($event ,users, 'banco')">
                        Cuenta
                    </vs-th>
                </vs-tr>
                </template>
                <template #tbody>
                <vs-tr
                    :key="i"
                    v-for="(tr, i) in $vs.getPage($vs.getSearch(users, search), page, max)"
                    :data="tr"
                    :is-selected="!!selected.includes(tr)"
                    style="vertical-align: top"
                >
                    <vs-td checkbox>
                        <vs-checkbox :disabled="!tr.cuenta" :val="tr" v-model="selected" />
                    </vs-td>
                    <vs-td>
                    {{ tr.alumno.nombre }}
                    </vs-td>
                    <vs-td>
                    {{ tr.alumno.programa }}
                    </vs-td>
                    <vs-td>
                    {{ tr.alumno.matricula }}
                    </vs-td>
                    <vs-td>
                    {{ tr.cargo.concepto }}
                    </vs-td>
                    <vs-td>
                    {{ tr.cargo.monto | currency}}
                    </vs-td>
                    <vs-td v-if="tr && tr.datos_bancarios">
                        <p class="mb-0">Tarjetahabiente: <strong>{{tr.datos_bancarios.tarjetahabiente}}</strong></p>
                        <p class="mb-0">Banco: <strong><md-chip class="mini-chip col-blue" ><strong>{{tr.datos_bancarios.banco}}</strong></md-chip></strong></p>
                        <p class="mb-0">Tipo: <strong>{{ tr.datos_bancarios.tipo }}</strong></p>
                        <p v-if="tr && tr.datos_bancarios && tr.datos_bancarios.cuenta" class="mb-0">Cuenta: <strong>{{ tr.datos_bancarios.cuenta }}</strong></p>
                    </vs-td>
                </vs-tr>
                </template>
                <template #footer>
                <vs-pagination v-model="page" :length="$vs.getLength($vs.getSearch(users, search), max)" />
                </template>
                <template #notFound>
                    No hay registros
                </template>
            </vs-table>
        </vs-row>
    </div>
</template>

<script>
import domicializacion from '../../../../api/requests/domicializacion'
import reportes from '../../../../api/requests/reportes.js'
export default {
    data(){
        return{
            search: '',
            allCheck: false,
            banco: '',
            bancoNombre: [],
            institucion: '',
            instituciones: [],
            bancoId: (new Date()).getTime(),
            institucionId: (new Date()).getTime(),
            ciclosEscolares: [],
            cicloEscolar: '',
            cicloId: (new Date()).getTime(),
            programaId: (new Date()).getTime(),
            gruposId: (new Date()).getTime(),
            programa: '',
            programas: [],
            selected: [],
            users: [],
            montoCobrar: 1,
            mes: this.getMes(),
            year: this.getYear(),
            page: 1,
            max: 30,
            grupos: [],
            grupo: '',
            errorGrupo: false,
            loadingGrupo: false,
            loadingCiclo: false
        }
    },
    created(){
        this.getBancos()
        this.getInstituciones()
    },
    methods: {
        selectAll(seleccion, tipo){
              let arr = []
            seleccion.forEach(i => {
              arr.push(i.id)
            })
            if(tipo == 'grupos'){
                this.grupo = arr
            }
        },
        deseleccionarAll(tipo){
            if(tipo == 'grupos'){
                this.grupo = ''
            }
        },
        getMes(){
            const d = new Date();
            const n = d.getMonth();
            const mes = [
                'Enero',
                'Febrero',
                'Marzo',
                'Abril',
                'Mayo',
                'Junio',
                'Julio',
                'Agosto',
                'Septiembre',
                'Octubre',
                'Noviembre',
                'Diciembre'
            ]
            return mes[n]
        },
        getYear(){
            const d = new Date();
            const n = d.getFullYear();
            return n
        },
        async getInstituciones(){
            try {
                const response = await reportes.getInstitucion()
                this.instituciones = response.data
            }
            catch{
                
            }
        },
        getAcciones(){
            this.getCicloEscolar(),
            this.getPrograma()
        },
        async getCicloEscolar() {
            this.loadingCiclo = true
            const { data: response } = await reportes.getCiclosEscolares(this.institucion)
            this.ciclosEscolares = response
            this.cicloId = (new Date()).getTime()
            this.loadingCiclo = false
        },
        async getGrupo() {
            if(this.cicloEscolar){
                try {
                    this.loadingGrupo = true
                    let params = {
                        "ciclo_escolar_id": this.cicloEscolar
                    }
                    const { data: response } = await reportes.getGrupo(this.institucion, params)
                    this.grupos = response
                    this.gruposId = (new Date()).getTime()
                    this.loadingGrupo = false
                }
                catch{
                    
                }
            }
        },
        async getPrograma() {
            const { data: response } = await reportes.getPrograma(this.institucion)
            this.programas = response.programas
            this.programaId = (new Date()).getTime()
        },
        async getBancos() {
            try {
                const response = await domicializacion.getBancos()
                this.bancoNombre = response.data
                this.bancoId = (new Date()).getTime()
            } catch (error) {

            }
        },
        async getGuardarSeleccionada(){
                // const loading = this.$vs.loading()
                try {
                    let dom = []
                    this.selected.forEach(i => {
                        let obj = {
                            'id': i.id,
                            'ciclo_escolar': this.cicloEscolar,
                            'cuenta': i.cuenta.id,
                            'institucion': this.institucion,
                            'programa': this.programa
                        }
                        dom.push(obj)
                    })
                    const domi = Object.assign(dom);
                    
                    const response = await domicializacion.getGuardarSeleccionada(domi)
                    var xhr = new XMLHttpRequest();
                    xhr.open('GET', `/api/v1/domiciliacion/solicitud/descargar/${response.data.data}`, true);
                    xhr.responseType = 'blob';

                    xhr.onload = function(e) {
                    if (this.status == 200) {
                        var blob = new Blob([this.response], {type: 'application/pdf'});
                        var link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = "Solicitud-Domiciliacion.pdf";
                        link.click();       
                    }
                    };

                    xhr.send();
                    this.active = false
                    loading.close()
                    
                } catch (error) {
                    // loading.close()
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        title: 'Algo salio mal',
                        text: 'Por favor contacta al administrador'
                    })
                }
        },
        async getArchivoBancos(banco){
            const loading = this.$vs.loading()
            try {
                let dom = []
                // this.selected.forEach(i => {
                //     dom.push(i.id)
                // })
                const base = {tipo: banco, institucion_id: this.institucion };
                const soli = {solicitudes: this.selected}
                const payload = Object.assign(base, soli);
                const response = await domicializacion.getArchivoBancos(payload)
                const nombreUrl = response.data.data

                loading.close()
                var xhr = new XMLHttpRequest();
                xhr.open('GET', `/api/v1/domiciliacion/banco/banamex/${response.data.data}/descargar`, true);
                xhr.responseType = 'blob';

                xhr.onload = function(e) {
                if (this.status == 200) {
                    var blob = new Blob([this.response], {type: 'application/x-download;charset=utf-8'});
                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = nombreUrl;
                    link.click();       
                }
                };

                xhr.send();
                this.active = false
                loading.close()

                // this.active = false
                loading.close()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    title: 'Descarga éxitosa'
                })
                
            } catch (error) {
                loading.close()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    title: 'Algo salio mal',
                    text: 'Por favor contacta al administrador'
                })
            }
        },
        async getInformacion(){
            const loading = this.$vs.loading()
            try {
                let params = {
                    page: this.page || 1,
                    size: this.max || 20,
                    id: this.personaId,
                    institucion: this.institucion,
                    ciclo_escolar: this.cicloEscolar,
                    grupo: this.grupo,
                    banco: this.banco
                }
                const { data: response = null } = await domicializacion.getGenerarArchivo(params) || {}
                const { data: dataTable = [], per_page = 20, total = 0 } = response|| {}
                this.pages = Math.ceil(total/per_page) || 0
                this.users = response.data
                loading.close()
            }
            catch{
                loading.close()
            }
        },
        // PARA SABER SI TIENEN UNA CUENTA 
        getInfoUsers(info){
            const result = []
            info.forEach(i => {
                if(i.cuenta){
                    result.push(i)
                }
            })
            return result
        }
    },
    watch: {
        page () {
            this.getInformacion()
        },
        cicloEscolar (){
            this.getGrupo()
        },
        institucion (){
            if(this.cicloEscolar != ''){
                this.getGrupo()
            }
        }
    }
}
</script>


<style lang="scss" scoped>
    .cardReportes{
        width: 95%;
        background-color:white;
        justify-content: space-between;
        @media only screen and (max-width: 768px) {
            margin: 16px;
        }
        @media only screen and (min-width: 768px) {
            margin: 16px 30px;
        }
        border-radius: 3px;
        padding: 10px
    }

    .vs-table__td{
        font-size: 0.9rem;
    }
</style>

<style scoped>
.col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
        font-size: 12px;
    }
</style>

